import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { PetChip } from 'components/UI/V2/Pets/PetChip/PetChip';
import { ResponseCard } from 'components/ClientIntakeForm/ResponseCard';
import Pet from '@spike/pet-model';

interface PetsResponsesProps {
    pets: Array<Pet>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 24,
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        petSlider: {
            'gap': 18,
            'width': '100%',
            'display': 'flex',
            'overflowX': 'auto',

            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        petResponses: {
            gap: 16,
            display: 'flex',
            flexDirection: 'column'
        }
    })
);

export const PetsResponses: React.FC<PetsResponsesProps> = props => {
    const classes = useStyles();

    const [selectedPetId, setSelectedPetId] = React.useState<number>();

    const petsWithResponses = React.useMemo(() => {
        return props.pets.filter(pet => pet.customQuestionResponses.length > 0);
    }, [props.pets]);

    const selectedPet = React.useMemo(() => {
        return props.pets.find(pet => pet.id === selectedPetId);
    }, [props.pets, selectedPetId]);

    React.useEffect(() => {
        if (props.pets.length > 0) {
            setSelectedPetId(props.pets[0].id);
        }
    }, [props.pets]);

    return (
        <div className={classes.root}>
            <div className={classes.petSlider}>
                {petsWithResponses.map(pet => (
                    <PetChip
                        key={pet.id}
                        petName={pet.name}
                        petType={pet.type!}
                        active={pet.id === selectedPetId}
                        onClick={() => setSelectedPetId(pet.id)}
                    />
                ))}
            </div>

            <div className={classes.petResponses}>
                {selectedPet?.customQuestionResponses.map(response => (
                    <ResponseCard
                        key={response.id}
                        response={response}
                    />
                ))}
            </div>
        </div>
    );
};
